module.exports = __webpack_public_path__ + "static/media/headerlogo.2d891a2b.png";